(function () {
  var header = document.querySelector('.ibscent-header');
  if (!header) return;

  var root = document.documentElement;
  var body = document.body;

  var anchor = header.parentElement;
  var main = document.querySelector('#MainContent, main, .content-for-layout');
  var isOverlay = header.getAttribute('data-overlay') === 'true';

  var headerHeight = -1;
  var anchorTop = -1;
  var lastTop = -1;

  function position() {
    var top = Math.max(0, anchorTop - window.scrollY);
    if (top === lastTop) return;
    lastTop = top;
    header.style.top = top + 'px';
  }

  function measure() {
    var h = header.offsetHeight;
    var base = anchor ? anchor.offsetTop : 0;
    if (h === headerHeight && base === anchorTop) {
      position();
      return;
    }
    headerHeight = h;
    anchorTop = base;
    root.style.setProperty('--ibscent-header-h', h + 'px');
    if (!isOverlay && main) {
      main.style.paddingTop = h + 'px';
    }
    lastTop = -1;
    position();
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      position();
    });
  }

  measure();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', measure);
  if (typeof ResizeObserver === 'function') {
    var headerResize = new ResizeObserver(measure);
    headerResize.observe(header);
    if (anchor && anchor !== header) headerResize.observe(anchor);
  }

  var desktop = window.matchMedia('(min-width: 1024px) and (hover: hover)');
  var groups = header.querySelectorAll('[data-menu-group]');
  var closeTimer;
  var CLOSE_DELAY = 100;
  function closeGroups(except) {
    groups.forEach(function (g) {
      if (g !== except) g.removeAttribute('open');
    });
  }
  groups.forEach(function (group) {
    group.addEventListener('mouseenter', function () {
      if (!desktop.matches) return;
      clearTimeout(closeTimer);
      closeGroups(group);
      group.setAttribute('open', '');
    });
    group.addEventListener('mouseleave', function () {
      if (!desktop.matches) return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        group.removeAttribute('open');
      }, CLOSE_DELAY);
    });
    group.addEventListener('toggle', function () {
      if (group.open) closeGroups(group);
    });
  });
  document.addEventListener('click', function (e) {
    if (!header.contains(e.target)) {
      clearTimeout(closeTimer);
      closeGroups(null);
    }
  });

  var scrollY = 0;
  function lockScroll() {
    scrollY = window.scrollY;
    body.style.position = 'fixed';
    body.style.top = '-' + scrollY + 'px';
    body.style.width = '100%';
  }
  function unlockScroll() {
    body.style.position = '';
    body.style.top = '';
    body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  function openDrawer() {
    var drawer = document.querySelector('[data-drawer]');
    if (!drawer) return;
    var drawerOverlay = document.querySelector('[data-drawer-overlay]');
    drawer.classList.add('is-open');
    if (drawerOverlay) drawerOverlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockScroll();
  }
  function closeDrawer() {
    var drawer = document.querySelector('[data-drawer]');
    if (!drawer || !drawer.classList.contains('is-open')) return;
    var drawerOverlay = document.querySelector('[data-drawer-overlay]');
    drawer.classList.remove('is-open');
    if (drawerOverlay) drawerOverlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    unlockScroll();
  }

  var ACC_FALLBACK = 420;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setupAccordions() {
    var drawer = document.querySelector('[data-drawer]');
    if (!drawer) return;
    var items = drawer.querySelectorAll('.ibscent-drawer__acc');
    if (!items.length) return;
    drawer.classList.add('ibscent-drawer--acc-js');
    items.forEach(function (item) {
      var group = item.getAttribute('name');
      if (group) {
        item.setAttribute('data-acc-group', group);
        item.removeAttribute('name');
      }
    });
  }

  setupAccordions();

  function accPanel(details) {
    return details.querySelector('.ibscent-drawer__acc-list');
  }

  function clearAccPending(details) {
    if (details.accTimer) {
      clearTimeout(details.accTimer);
      details.accTimer = null;
    }
    if (details.accSettle) {
      details.removeEventListener('transitionend', details.accSettle);
      details.accSettle = null;
    }
  }

  function settleAcc(details, open) {
    var panel = accPanel(details);
    clearAccPending(details);
    details.classList.remove('is-animating');
    details.classList.remove('is-collapsing');
    if (panel) {
      panel.style.height = '';
      panel.style.paddingBottom = '';
      panel.style.overflow = '';
      panel.style.opacity = '';
    }
    details.open = open;
  }

  function animateAcc(details, open) {
    var panel = accPanel(details);
    if (!panel || reducedMotion.matches) {
      settleAcc(details, open);
      return;
    }
    clearAccPending(details);

    var startHeight = details.open ? panel.getBoundingClientRect().height : 0;
    var startPad = details.open ? window.getComputedStyle(panel).paddingBottom : '0px';
    var startOpacity = details.open ? '1' : '0';

    panel.style.height = '';
    panel.style.paddingBottom = '';
    panel.style.opacity = '';
    if (open) details.open = true;

    var endPad = open ? window.getComputedStyle(panel).paddingBottom : '0px';
    var endHeight = open ? panel.getBoundingClientRect().height : 0;

    panel.style.overflow = 'hidden';
    panel.style.height = startHeight + 'px';
    panel.style.paddingBottom = startPad;
    panel.style.opacity = startOpacity;
    details.classList.add('is-animating');
    details.classList.toggle('is-collapsing', !open);

    void panel.offsetHeight;

    panel.style.height = endHeight + 'px';
    panel.style.paddingBottom = endPad;
    panel.style.opacity = open ? '1' : '0';

    var settle = function (e) {
      if (e && (e.target !== panel || e.propertyName !== 'height')) return;
      settleAcc(details, open);
    };
    details.accSettle = settle;
    details.addEventListener('transitionend', settle);
    details.accTimer = setTimeout(function () {
      settleAcc(details, open);
    }, ACC_FALLBACK);
  }

  function closeAccSiblings(details) {
    var group = details.getAttribute('data-acc-group');
    if (!group) return;
    document.querySelectorAll('[data-acc-group="' + group + '"]').forEach(function (other) {
      if (other !== details && other.open) animateAcc(other, false);
    });
  }

  function toggleAcc(details) {
    if (details.open && !details.classList.contains('is-collapsing')) {
      animateAcc(details, false);
      return;
    }
    closeAccSiblings(details);
    animateAcc(details, true);
  }

  function switchDrawerTab(tab) {
    var name = tab.getAttribute('data-drawer-tab');
    document.querySelectorAll('[data-drawer-tab]').forEach(function (t) {
      t.classList.toggle('is-active', t === tab);
    });
    document.querySelectorAll('[data-drawer-panel]').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-drawer-panel') === name);
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { openDrawer(); return; }
    if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }
    if (e.target.closest('[data-drawer-overlay]')) { closeDrawer(); return; }
    var tab = e.target.closest('[data-drawer-tab]');
    if (tab) { switchDrawerTab(tab); return; }
    var summary = e.target.closest('.ibscent-drawer__acc-summary');
    if (summary && summary.parentElement && summary.parentElement.tagName === 'DETAILS') {
      e.preventDefault();
      toggleAcc(summary.parentElement);
    }
  });

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-locale-toggle]');
    if (toggle) {
      e.stopPropagation();
      var locale = toggle.closest('[data-locale]');
      if (locale) locale.classList.toggle('is-open');
      return;
    }
    document.querySelectorAll('[data-locale].is-open').forEach(function (locale) {
      if (!locale.contains(e.target)) locale.classList.remove('is-open');
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      closeGroups(null);
      document.querySelectorAll('[data-locale].is-open').forEach(function (locale) {
        locale.classList.remove('is-open');
      });
    }
  });
})();
